
import { Component, Vue } from 'vue-property-decorator'
import { apiPaymentConfigSet, apiPaymentConfigGet } from '@/api/setting'
import MaterialSelect from '@/components/material-select/index.vue'
@Component({
    components: {
        MaterialSelect
    }
})
export default class PayMethodEdit extends Vue {
    /** S Data **/

    identity: Number = 0

    status: any = ''

    // 支付配置設置的數據
    paymentConfigData = {
        sub_mch_id: '',
        name: '', //支付名稱
        icon: '', //支付图标
        sort: '', //排序
        remark: '', //備註
        merchant_type: 'ordinary_merchant', //（微信支付 ｜｜ 支付寶）商户類型ordinary_merchant-普通商户
        interface_version: 'v2', //微信支付接口版本v2-v2
        mch_id: '', //微信支付商户号
        pay_sign_key: '', //微信商户支付API密钥
        apiclient_cert: '', //微信支付证书
        apiclient_key: '', //微信支付证书密钥
        pattern: '', //模式：normal_mode普通商户
        app_id: '', //应用ID
        private_key: '', //支付寶公钥
        ali_public_key: '', //应用私钥
        pay_way: '',
        wechat_public_serial: '', //公钥id
        wechat_public_cert: '', //公钥
        // 蓝新金流配置
        merchant_id: '', //蓝新金流商户编号
        hash_key: '', //蓝新金流Hash Key
        hash_iv: '', //蓝新金流Hash IV
        version: '1.5', //蓝新金流接口版本
        response_type: 'JSON', //返回格式
        time_zone: '+08:00', //时区
        mode: 'prod', //环境模式，默認生产环境
        // LINE Pay 配置
        channel_id: '', //LINE Pay 渠道 ID
        channel_secret: '' //LINE Pay 渠道密钥
    }

    // 表单验证
    rules: any = {
        name: [{ required: true, message: '請輸入顯示名稱', trigger: 'blur' }],
        icon: [{ required: true, message: '請輸入上傳图标', trigger: 'change' }],
        mch_id: [
            {
                required: true,
                message: '請輸入微信支付商户号',
                trigger: 'blur'
            }
        ],
        pay_sign_key: [
            {
                required: true,
                message: '請輸入微信商户支付API密钥',
                trigger: 'blur'
            }
        ],
        apiclient_cert: [{ required: true, message: '請輸入微信支付证书', trigger: 'blur' }],
        apiclient_key: [
            {
                required: true,
                message: '請輸入微信支付证书密钥',
                trigger: 'blur'
            }
        ],
        private_key: [{ required: true, message: '請輸入支付寶公钥', trigger: 'blur' }],
        ali_public_key: [{ required: true, message: '請輸入应用私钥', trigger: 'blur' }],
        app_id: [{ required: true, message: '請輸入应用ID', trigger: 'blur' }],
        // 蓝新金流配置验证
        merchant_id: [{ required: true, message: '請輸入蓝新金流商户编号', trigger: 'blur' }],
        hash_key: [{ required: true, message: '請輸入蓝新金流Hash Key', trigger: 'blur' }],
        hash_iv: [{ required: true, message: '請輸入蓝新金流Hash IV', trigger: 'blur' }],
        version: [{ required: true, message: '請輸入蓝新金流接口版本', trigger: 'blur' }],
        response_type: [{ required: true, message: '請選擇返回格式', trigger: 'change' }],
        time_zone: [{ required: true, message: '請輸入时区', trigger: 'blur' }],
        mode: [{ required: true, message: '請選擇环境模式', trigger: 'change' }],
        // LINE Pay 配置验证
        channel_id: [{ required: true, message: '請輸入LINE Pay 渠道 ID', trigger: 'blur' }],
        channel_secret: [{ required: true, message: '請輸入LINE Pay 渠道密钥', trigger: 'blur' }],
        sort: [
            { required: true, message: '請輸入排序', trigger: 'blur' },
            {
                type: 'number',
                pattern: !/-|\+|(\.[0-9])/,
                message: '請輸入正確的排序',
                trigger: 'blur'
            }
        ]
    }

    /** E Data **/

    /** S Methods **/

    // 獲取支付方式數據
    getPaymentConfigDetail() {
        apiPaymentConfigGet({
            id: this.identity
        })
            .then((res: any) => {
                // 解构出结果的
                const result = {
                    ...res.config,
                    ...res
                }

                delete result.config

                // if (result.pay_way == 2) {
                //     result.interface_version = 'v2'
                // }
                if (result.pay_way == 3) {
                    result.mode = 'normal_mode'
                }
                // result.merchant_type = 'ordinary_merchant'

                this.paymentConfigData = result
            })
            .catch(() => {
                this.$message.error('數據初始化失敗，請刷新重载！')
            })
    }

    // 點擊表单提交
    onSubmit(formName: string) {
        // 验证表单格式是否正確
        const refs = this.$refs[formName] as HTMLFormElement
        refs.validate((valid: boolean): any => {
            if (!valid) {
                return
            }
            if ((this.paymentConfigData as any).sort <= 0) {
                return this.$message.error('請輸入正整数')
            }
            this.handlePayConfigEdit()
        })
    }

    // 編輯支付配置
    handlePayConfigEdit() {
        const params = this.paymentConfigData
        const id: number = this.identity as number
        apiPaymentConfigSet({ ...params, id })
            .then(() => {
                setTimeout(() => this.$router.go(-1), 500)
            })
            .catch(() => {
                this.$message.error('保存失敗!')
            })
    }

    // 複製域名
    onCopy() {
        const createInput = document.createElement('input')
        createInput.value = 'http://xxx.com/pay/'
        document.body.appendChild(createInput)
        createInput.select() // 選擇對象
        document.execCommand('Copy') // 执行瀏覽器複製命令
        createInput.style.display = 'none'
        this.$message({ message: '複製成功', type: 'success' })
    }

    /** E Methods **/

    /** S Life Cycle **/
    created() {
        const query: any = this.$route.query
        this.identity = query.id
        this.getPaymentConfigDetail()
    }
    /** E Life Cycle **/

    /** S Compute Attr **/

    /** E Compute Attr **/
}
